import { render } from "./EditSliderAwardHome.vue?vue&type=template&id=3f2463f0"
import script from "./EditSliderAwardHome.vue?vue&type=script&lang=js"
export * from "./EditSliderAwardHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__